/**
 * Back when the previous history entry is this app's own (react-router keeps its index in `history.state.idx`), else
 * `fallback` (the page was opened from a link: Back would leave the app).
 */
export function backOr(fallback: () => void) {
  const idx = (window.history.state as { idx?: unknown } | null)?.idx;
  if (typeof idx === 'number' && idx > 0) window.history.back();
  else fallback();
}
